<template>
  <v-dialog v-model="isOpen" max-width="600">
    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <div>{{ $t("proof.tags.dialogTitle") }}</div>
      </v-card-title>

      <v-card-text>
        <v-chip-group column>
          <v-chip v-for="tag in tags" :key="tag._id" small class="ma-1">
            {{ tag.tag }}
          </v-chip>
        </v-chip-group>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text color="primary" @click="isOpen = false">
          {{ $t("general.back") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ProofTagsDialog",
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
  },
};
</script>
